import axios from "axios";
import { getAuthHeaders } from "../helpers";

/**
 * @function getClinicGroupList
 * @param id
 * @description This function  will fetch the clinic group list.
 */
export const getClinicList = (
  pageNo,
  searchText,
  stateName,
  bankDetails = null,
  specModuleId,
  isHospital,
  selectedFeatureFlag
) => {
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  let url = `${baseUrl}/admin/clinics?page=${pageNo}&perpage=10`;
  if (searchText) url = `${url}&search_text=${searchText}`;
  if (stateName) url = `${url}&filter_type=state&filter_text=${stateName}`;
  if (bankDetails !== null)
    url += `$${
      url.includes("?")
        ? `&bank_details=${bankDetails}`
        : `?bank_details=${bankDetails}`
    }`;
  if (specModuleId && specModuleId !== "All" && specModuleId !== "all")
    url = `${url}&spec_module_id=${specModuleId}`;
  if (isHospital) {
    url += `&is_hospital=true`;
  }
  if (selectedFeatureFlag) {
    url += `&${selectedFeatureFlag}=true`;
  }
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getClinicGroupList
 * @param id
 * @description This function  will fetch the clinic group list.
 */
export const getPhysicalClinicList = (
  pageNo,
  searchText = null,
  isPrivate = false,
  perPage = 10
) => {
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const url =
    `${baseUrl}/admin/clinics?page=${pageNo}` +
    `&perpage=${perPage}` +
    (searchText ? `&search_text=${searchText}` : "") +
    `&is_private=${isPrivate}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getClinicDetails
 * @desc  get clinic details
 */

export const getClinicDetails = clinicId => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/clinics/${clinicId}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getSpecModules
 * @desc  get all spec modules
 */

export const getSpecModules = () => {
  let url = `${process.env.REACT_APP_SERVER_URL}/spec_modules`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

export const activateSpecModule = (clinicId, moduleId) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/clinics/${clinicId}/spec_modules/${moduleId}/activate`;
  return axios.post(
    url,
    {},
    {
      headers: getAuthHeaders()
    }
  );
};

export const deactivateSpecModule = (clinicId, moduleId) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/clinics/${clinicId}/spec_modules/${moduleId}/deactivate`;
  return axios.post(
    url,
    {},
    {
      headers: getAuthHeaders()
    }
  );
};

export const activateIpdModule = (clinicId, moduleId, isInabled) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/clinics/${clinicId}/clinic_settings`;
  const params = {
    settings: {
      [moduleId]: isInabled
    }
  };
  return axios.post(url, params, {
    headers: getAuthHeaders()
  });
};

export const updateClinicDetail = (clinicId, params) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/clinics/${clinicId}`;
  return axios.put(url, params, {
    headers: getAuthHeaders()
  });
};

export const getClinicAdmins = (clinicId, page, perPage) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/clinics/${clinicId}/clinic_admin?page=${page}&perpage=${perPage}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

export const createClinicAdmin = (clinicId, params) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/clinics/${clinicId}/clinic_admin/sign_up`;
  return axios.post(url, params, {
    headers: getAuthHeaders()
  });
};
export const updateClinicAdmin = (clinicId, params, adminId) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/clinics/${clinicId}/clinic_admin/${adminId}`;
  return axios.put(url, params, {
    headers: getAuthHeaders()
  });
};
export const deleteClinicAdmin = (clinicId, adminId) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/clinics/${clinicId}/clinic_admin/${adminId}`;
  return axios.delete(url, {
    headers: getAuthHeaders()
  });
};

export const createHospital = params => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/users/sign_up`;
  return axios.post(url, params, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getTelemedicinePayments
 * @param clinicId
 * @param pageNo
 * @param perPage
 * @description This function will fetch the telemedicine payments list for a clinic.
 */
export const getTelemedicinePayments = (clinicId, pageNo = 1, perPage = 10, filters = {}) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/clinics/${clinicId}/payments/list?page=${pageNo}&perpage=${perPage}`;

  // Add filter parameters to URL
  if (filters.payment_type) {
    url += `&payment_type=${filters.payment_type}`;
  }
  if (filters.start_date) {
    url += `&start_date=${filters.start_date}`;
  }
  if (filters.end_date) {
    url += `&end_date=${filters.end_date}`;
  }

  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function createManualPayment
 * @param data
 * @description This function will create a manual billing payment entry.
 */
export const createManualPayment = data => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/billing_payments/manual`;
  return axios.post(url, data, {
    headers: getAuthHeaders()
  });
};
